import { makeStyles } from '@material-ui/core/styles';

// Transient highlight applied to a section after the go-to-section arrow scrolls to it
// (#30230 follow-up). A single ~1.2s orange-tinted flash that fades back to transparent, drawing
// the eye to the section the operator was sent to without leaving a persistent background.
// `forwards` holds the transparent end state so nothing lingers; useScroll removes the class anyway.
// Honors prefers-reduced-motion: the flash is suppressed (the scroll itself still happens).
export default makeStyles((theme) => ({
  '@keyframes sectionHighlightFlash': {
    '0%': {
      backgroundColor: theme.colorPalette.orange_50_op_50,
      boxShadow: `0 0 0 4px ${theme.colorPalette.orange_50_op_50}`
    },
    '100%': {
      backgroundColor: 'transparent',
      boxShadow: '0 0 0 4px transparent'
    }
  },
  highlighted: {
    animation: '$sectionHighlightFlash 1.2s ease-in-out forwards',
    borderRadius: theme.sizes.roundCorners,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none'
    }
  }
}));
